import React, { type ReactNode } from 'react';
import { useTabPanel } from '@atlaskit/tabs';
import { Box, xcss } from '@atlaskit/primitives';

const containerStyles = xcss({
	// Create space between TabList and TabPanel so it matches the top margin for non-tabbed content
	marginBlockStart: 'space.400',
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.200',
	width: '100%',
});

interface TabPanelProps {
	children: ReactNode;
}

const TabPanel = ({ children }: TabPanelProps) => {
	const panelAttributes = useTabPanel();
	return (
		<Box xcss={containerStyles} {...panelAttributes}>
			{children}
		</Box>
	);
};

export default TabPanel;
